// prompts.<area>.<key>: the suggested questions (services/platform-agent/platformAgentSuggestions.js), sent as typed.
// {{dish}} is a dish on the restaurant's menu, {{amount}} an amount in its currency (both from the picker).
export default {
  title: 'Hallo {{first_name}}, was brauchst du für {{restaurant}}?',
  title_no_name: 'Hallo, was brauchst du für {{restaurant}}?',
  text: 'Ich beantworte Fragen zu {{restaurant}} und ändere Dinge für dich. Nichts ändert sich, bevor du es freigibst.',
  suggestions: 'Vorschläge',
  // No restaurant selected (D18): Amigo asks which restaurant; the prompts let it ask for the restaurant's name.
  no_restaurant: {
    title: 'Hallo {{first_name}}, um welches Restaurant geht es?',
    title_no_name: 'Hallo, um welches Restaurant geht es?',
    text: 'Nenn das Restaurant in deiner Nachricht, dann kümmere ich mich darum, ohne es vorher zu öffnen. Nichts ändert sich, bevor du es freigibst.',
    prompts: {
      sunday_hours: 'Ändere die Sonntagszeiten eines Restaurants auf 12:00–21:00',
      close_several: 'Schließ mehrere Restaurants am 24. Dezember',
    },
  },
  prompts: {
    reports: {
      top_dishes: 'Was waren letzten Monat die 10 meistbestellten Gerichte?',
      sales_vs_last_month: 'Wie war der Umsatz im Vergleich zum Vormonat?',
    },
    menu: {
      raise_dish_price: 'Erhöh den Preis von {{dish}} um {{amount}}',
      dish_sold_out: '{{dish}} als ausverkauft markieren',
      dishes_without_photo: 'Welche Gerichte haben kein Foto?',
    },
    hours: {
      holiday_hours: 'Änder unsere Öffnungszeiten für den 24. Dezember',
    },
    order_settings: {
      minimum_order: 'Erhöh den Mindestbestellwert auf {{amount}}',
    },
    marketing: {
      promo_code: 'Erstell einen Gutscheincode über 10 % für dieses Wochenende',
    },
    my_info: {
      phone_number: 'Aktualisier unsere Telefonnummer',
    },
  },
};
